import { SHIPPING_LIMITATIONS } from 'App/featuresFlags';
import useGetTags from 'domains/Auth/hooks/useGetTags';

function useHasShippingLimitations(): boolean {
  const tags = useGetTags();
  return tags.includes(SHIPPING_LIMITATIONS);
}

export default useHasShippingLimitations;
